import React from "react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$lang/serverError")({
  component: React.lazy(() =>
    import("@/pages/errorPages/serverError").then((mod) => ({
      default: mod.ServerError,
    })),
  ),
});
